@use "../../../../styles/variables" as *;
@use "../../../../styles/mixins" as *;

.clickable-svg {
  cursor: pointer;
}

#chevron-up {
  width: 1.3rem;
}

#chevron-down {
  width: 1.3rem;
}

#close-circle {
  width: 1.25rem;
}

#heart-red,
#heart-grey,
#phone,
#navigation {
  width: 1.5rem;
}

#my-location {
  width: 1.2rem;
}

#back-arrow,
#search,
#close {
  width: 1rem;

  @include desktop {
    width: 1.2rem;
  }
}

#error {
  width: 1.8rem;
}

#png {
  width: 1.65rem;
}

#places {
  width: 1.5rem;
}

#nyer {
  width: 1.5rem;
  height: 2rem;
}
